
import { defineComponent, PropType, ref } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import BillingTemplatesFormFieldDeliveryPolicyType from '@/components/billing-templates/form-fields/delivery-policy-type.vue'
import BillingTemplatesFormFieldElectronicOperator from '@/components/billing-templates/form-fields/billing-electronic-operator.vue'
import BillingTemplatesFormFieldElectronicAddress from '@/components/billing-templates/form-fields/billing-electronic-address.vue'
import BillingTemplatesFormFieldBillingEmail from '@/components/billing-templates/form-fields/billing-email.vue'

import { DeliveryPolicy, useBillingTemplateModule } from '@/modules/billing-templates'
import { useFormModule } from '@/modules/_shared/forms'
import { useElectronicOperatorsModule } from '@/modules/electronic-operators'

export default defineComponent({
    name: 'billing-templates-edit-delivery-policy-dialog',
    components: {
        BillingTemplatesFormFieldDeliveryPolicyType,
        BillingTemplatesFormFieldElectronicOperator,
        BillingTemplatesFormFieldElectronicAddress,
        BillingTemplatesFormFieldBillingEmail
    },
    props: {
        deliveryPolicy: {
            type: Object as PropType<DeliveryPolicy>,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        billingTemplateId: {
            type: String,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: DeliveryPolicy) => void>,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { assignElectronicDeliveryPolicy, assignEmailDeliveryPolicy, assignMailDeliveryPolicy } = useBillingTemplateModule()

        const form = ref<QForm>()
        const deliveryPolicyModel = ref(props.deliveryPolicy)

        const { getElectronicOperators, electronicOperators } = useElectronicOperatorsModule()
        getElectronicOperators()

        const sendRequest = async () => {
            const selectedElectronicOperator = electronicOperators.value.find(operator => +operator.id === +deliveryPolicyModel.value.electronicOperatorId)

            switch (deliveryPolicyModel.value.deliveryPolicyType) {
            case 'mail':
                await assignMailDeliveryPolicy(props.organizationId, props.billingTemplateId, {
                    organizationId: props.organizationId,
                    billingTemplateId: props.billingTemplateId
                })
                break
            case 'email':
                await assignEmailDeliveryPolicy(props.organizationId, props.billingTemplateId, {
                    organizationId: props.organizationId,
                    billingTemplateId: props.billingTemplateId,
                    email: deliveryPolicyModel.value.email
                })
                break
            case 'electronic':
                await assignElectronicDeliveryPolicy(props.organizationId, props.billingTemplateId, {
                    organizationId: props.organizationId,
                    billingTemplateId: props.billingTemplateId,
                    electronicAddress: deliveryPolicyModel.value.electronicAddress,
                    electronicOperatorId: deliveryPolicyModel.value.electronicOperatorId,
                    electronicOperatorCode: selectedElectronicOperator?.code || ''
                })
            }
        }

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Delivery policy changed')
        ).then(() => {
            onDialogOK()
            props.updateCallback(deliveryPolicyModel.value)
        })

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            deliveryPolicyModel,
            onSubmit,
            form
        }
    }
})
